import { Link } from "react-router-dom";
import { Header } from "../components/shared/Header";
import { Footer } from "../components/shared/Footer";
import { usePageMeta } from "../hooks/usePageMeta";

export default function NotFoundPage() {
  usePageMeta("Página não encontrada | Gepeto", "A página solicitada não foi encontrada no Gepeto.");
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main data-testid="not-found-page" className="flex flex-1 items-center">
        <div className="mx-auto w-full max-w-7xl px-4 py-24 sm:px-6 lg:px-8">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-emerald-500">Erro 404</p>
          <h1 className="mt-3 text-4xl font-semibold tracking-tight text-slate-100 sm:text-5xl">Protocolo não localizado</h1>
          <p className="mt-4 max-w-xl text-slate-300">A página que você procura não existe ou foi movida.</p>
          <Link to="/" data-testid="not-found-home-link" className="btn-primary mt-10">Voltar ao início</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
